import { render, staticRenderFns } from "./OrdresPendentsG.vue?vue&type=template&id=696bcc93"
import script from "./OrdresPendentsG.vue?vue&type=script&lang=js"
export * from "./OrdresPendentsG.vue?vue&type=script&lang=js"
import style0 from "./OrdresPendentsG.vue?vue&type=style&index=0&id=696bcc93&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports